import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnnouncementCategoryResponseModel } from 'data/announcement/announcement.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AnnouncementCategoryResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AnnouncementCategoryResponseModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const announcementCategorySlice = createSlice({
  name: 'announcementCategory',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default announcementCategorySlice;
